export type RadiiVariantsType = 'r2' | 'r4' | 'r8' | 'r12' | 'r16' | 'r24' | 'r32' | 'r48';

export type RadiiAliases = Record<RadiiVariantsType, number>;
export type Radii = number[] & Partial<RadiiAliases>;

const radii: Radii = [2, 4, 8, 12, 16, 24, 32, 48];

export const radiiAliases: RadiiAliases = {
  /** @returns `2` */
  r2: radii[0],
  /** @returns `4` */
  r4: radii[1],
  /** @returns `8` */
  r8: radii[2],
  /** @returns `12` */
  r12: radii[3],
  /** @returns `16` */
  r16: radii[4],
  /** @returns `24` */
  r24: radii[5],
  /** @returns `32` */
  r32: radii[6],
  /** @returns `48` */
  r48: radii[7],
};

Object.keys(radiiAliases).map(radius => {
  const radiusKey = radius as RadiiVariantsType;

  radii[radiusKey] = radiiAliases[radiusKey];
});

export const radiiVariants = Object.keys(radii) as RadiiVariantsType[];

export default radii;
